
import React from 'react';
import MemberModal from '@/components/users/MemberModal';
import { Contact } from './types';
import { ColumnConfigItem } from '@/hooks/column-config';

interface ContactsModalsProps {
  isAddModalOpen: boolean;
  isEditModalOpen: boolean;
  isColumnModalOpen: boolean;
  selectedContact: Contact | null;
  onCloseAddModal: () => void;
  onCloseEditModal: () => void;
  onCloseColumnModal: () => void;
  onSaveColumnConfig: (config: ColumnConfigItem[]) => Promise<boolean>;
  columnConfig: ColumnConfigItem[];
  tableType: 'contacts' | 'companies';
}

/**
 * ContactsModals component manages all modals for the contacts page
 */
const ContactsModals: React.FC<ContactsModalsProps> = ({
  isAddModalOpen,
  isEditModalOpen,
  isColumnModalOpen,
  selectedContact,
  onCloseAddModal,
  onCloseEditModal,
  onCloseColumnModal,
  onSaveColumnConfig,
  columnConfig,
  tableType
}) => {
  return (
    <>
      {/* Add Contact Modal */}
      <MemberModal
        isOpen={isAddModalOpen}
        onClose={onCloseAddModal}
        mode="add"
        data-test-id="add-contact-modal"
      />

      {/* Edit Contact Modal */}
      <MemberModal
        isOpen={isEditModalOpen}
        onClose={onCloseEditModal}
        member={selectedContact}
        mode="edit"
        data-test-id="edit-contact-modal"
      />

      {/* Column Management Modal - Simplified placeholder */}
      {isColumnModalOpen && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
          <div className="bg-background border rounded-lg p-6 max-w-md w-full mx-4">
            <h2 className="text-xl font-semibold mb-4">Column Management</h2>
            <p className="text-muted-foreground mb-4">
              Column management functionality is currently being updated.
            </p>
            <button 
              onClick={onCloseColumnModal}
              className="px-4 py-2 bg-primary text-primary-foreground rounded hover:bg-primary/90"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ContactsModals;
